"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const currency_input_styled_1 = require("./currency-input.styled");
exports.CurrencyInput = (props) => {
    const classNames = [];
    if (props.className)
        classNames.push(props.className);
    const rtiProps = {
        type: 'number',
        classNames: classNames.join(' '),
        value: props.value,
        onChange: props.onChange
    };
    return React.createElement(currency_input_styled_1.StyledCurrencyInput, null,
        React.createElement("div", { className: "currency__label" }, "\u00A3"),
        React.createElement("input", Object.assign({}, rtiProps)));
};
//# sourceMappingURL=CurrencyInput.js.map